import { render, staticRenderFns } from "./AlfaSettingsBlock.vue?vue&type=template&id=3a721cfc&scoped=true&"
import script from "./AlfaSettingsBlock.vue?vue&type=script&lang=js&"
export * from "./AlfaSettingsBlock.vue?vue&type=script&lang=js&"
import style0 from "./AlfaSettingsBlock.vue?vue&type=style&index=0&id=3a721cfc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a721cfc",
  null
  
)

export default component.exports